/* Copyright 2013 - 2022 Waiterio LLC */
/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'

const lineSeparator = css({
  height: 1,
  borderTop: '1px solid var(--color-background)',
  margin: '32px 16px',
  padding: 0,
})

const DrawerSeparator = () => <div css={lineSeparator} />

export default DrawerSeparator
